import eventEmitter, { Events } from '../../../pure-js/libs/EventEmitter'
import { captureException } from './SentryHelper'

export const captureAndNotifyError = (err: Error) => {
  captureException(err)
  eventEmitter.emit(Events.NEW_SERVER_ERROR, err.message)
}
